import { render, staticRenderFns } from "./StudentsInCourse.vue?vue&type=template&id=1e14cb06"
import script from "./StudentsInCourse.vue?vue&type=script&lang=ts"
export * from "./StudentsInCourse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports